import styled from 'styled-components';
import { Heading5Mixin, TableTextMixin } from '@qover/typography';
import { SummarySideCardMixin } from './summary.styles';

export const SummaryAdvantages = styled.div`
  display: none;
  ${SummarySideCardMixin};
  h5 {
    ${Heading5Mixin};
    margin-top: 0;
    margin-bottom: 20px;
  }
  ul {
    ${TableTextMixin};
    padding-left: 16px;
    margin: 0;
    li {
      padding-left: 10px;
    }
    li + li {
      margin-top: 6px;
    }
  }
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    display: block;
  }
`;
